import { testimonialData } from '@/mocks/homeData';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
          (Kundenbewertungen)
        </h2>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-900 mb-6">
            <i className="ri-star-fill text-secondary-400 text-sm"></i>
            <span className="text-background-50 text-sm font-semibold">{testimonialData.rating}</span>
          </div>

          <blockquote className="text-foreground-800 text-base md:text-lg leading-relaxed font-heading italic mb-8">
            &ldquo;{testimonialData.text}&rdquo;
          </blockquote>

          <div className="flex items-center justify-center gap-3">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
              <span className="text-accent-700 font-semibold text-sm">{testimonialData.name.charAt(0)}</span>
            </div>
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground-900">{testimonialData.name}</p>
              <p className="text-xs text-foreground-500">{testimonialData.role}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}